import { Search } from "@mui/icons-material";
import { Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SmollLogo from "../../assets/images/Smoll_ESTBN_Logo.png";
import Shell from "../../assets/svg/Shell oil 2.svg";
import "./Supplier.css";

// const BEARER_TOKEN = "1|uXWWHVAxUbLR94IuQ07nZUT5306vlnjfGFo4AUoR16bcf002";

const API_URL =
  "https://estbn.com/EstbnNew/public/api/portal/providers/80/batches";

const Supplier_order = () => {
  const { user } = useSelector((state) => state.auth);

  const BEARER_TOKEN = user?.token;

  const [searchForPermissions, setSearchForPermissions] = useState("");
  const navigate = useNavigate();

  // State to hold fetched data (batches)
  const [batches, setBatches] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  // --- Data Fetching Logic ---
  useEffect(() => {
    const fetchBatches = async () => {
      // setLoading(true);
      // setError(null);
      try {
        const response = await fetch(API_URL, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${BEARER_TOKEN}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || `HTTP error! status: ${response.status}`
          );
        }

        const result = await response.json();

        if (result.success) {
          setBatches(result.data.batches);
          console.log("Fetched batches:", result.data.batches);
        }
      } catch (e) {
        console.error("Error fetching batches:", e);
      }
    };

    fetchBatches();
  }, []); // Empty dependency array means this runs once on mount

  // const columns = [
  //   {
  //     name: "Order ID", // Mapping Batch ID to Order ID
  //     selector: (row) => (
  //       <div className="clac" onClick={() => open(row)}>
  //         {row.id}
  //       </div>
  //     ),
  //     sortable: true,
  //   },
  //   {
  //     name: "Order Date", // Mapping Batch Created Date to Order Date
  //     selector: (row) => {
  //       const date = new Date(row.created_at);
  //       const dateStr = date.toLocaleDateString();
  //       const timeStr = date.toLocaleTimeString();
  //       return (
  //         <>
  //           {/* <div>{timeStr}</div> */}
  //           <div>{dateStr}</div>
  //         </>
  //       );
  //     },
  //     sortable: true,
  //   },
  //   {
  //     name: "Order Status", // Mapping Batch Status to Order Status (might not align conceptually)
  //     selector: (row) => row.status, // e.g., 'active'
  //     sortable: true,
  //   },
  //   {
  //     name: "Total", // Mapping first transaction's total price to Total
  //     selector: (row) =>
  //       row.transactions && row.transactions.length > 0
  //         ? `${row.transactions[0].total_price} EGP` // Assuming EGP based on PDF mock
  //         : "N/A",
  //     sortable: true,
  //   },
  //   {
  //     name: "Batch Value", // Renamed from "Contact Info" as it doesn't fit batch data well. Using batch value instead.
  //     selector: (row) => `${row.value} EGP`,
  //     sortable: true,
  //   },

  // ];
  const columns = [
    {
      field: "id",
      headerName: "Order ID",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="clac" onClick={() => open(params.row)}>
            {params.row.id}
          </div>
        );
      },
    },
    {
      field: "created_at",
      headerName: "Order Date",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        const date = new Date(params.row.created_at);
        const dateStr = date.toLocaleDateString();
        const timeStr = date.toLocaleTimeString();
        return (
          <>
            {/* <div>{timeStr}</div> */}
            <div>{dateStr}</div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Order Status",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {},
    },
    {
      field: "transactions",
      headerName: "Total",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <div>
            {params.row.transactions && params.row.transactions.length > 0
              ? `${params.row.transactions[0].total_price} EGP`
              : "N/A"}
          </div>
        );
      },
    },
    {
      field: "value",
      headerName: "Batch Value",
      flex: 0.9,
      minWidth: 110,
      renderCell: (params) => {},
    },

    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {},
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };
  const [selectedRows, setSelectedRows] = useState([]);

  // --- Model State and Handlers ---
  const [show, setShow] = useState(false);
  const [oneRow, setOneRow] = useState(null); // Will hold the selected batch object for the modal

  const close = () => {
    setShow(false);
    setOneRow(null); // Clear selected row when closing
  };

  // Open modal with selected batch data
  const open = (row) => {
    setShow(true);
    setOneRow(row); // Store the selected batch object
    console.log("Selected row (batch) for modal:", row);
  };

  const columnsModel = [
    {
      name: "Product/Batch ID", // Renamed for clarity
      selector: (row) => (
        <div className="clac">{row.id || row.variation?.sku || "N/A"}</div>
      ), // Use Batch ID or Variation SKU/ID
      sortable: true,
    },
    {
      name: "Product Name",
      selector: (row) => (
        <div className="ProdectNameModel">
          <img src={Shell} alt="" />
          <div className="">
            <div>{row.variation?.name || "N/A"}</div> {/* Variation name */}
            {/* Using transaction quantity and unit price */}
            <div>
              Qty:{" "}
              {row.transactions && row.transactions.length > 0
                ? row.transactions[0].quantity
                : "N/A"}
            </div>
            <div>
              Unit Price:{" "}
              {row.transactions && row.transactions.length > 0
                ? `${row.transactions[0].unit_price} EGP`
                : "N/A"}
            </div>
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Category", // Mapping batch status or transaction type - doesn't map well to product categories
      selector: (row) => (
        // Remove complex icon logic as category info isn't in batch API response
        <div>{row.status || row.transactions?.[0]?.type || "N/A"}</div> // Using batch status or transaction type as placeholder
      ),
      sortable: true,
    },
    {
      name: "Total Purchase Price", // Renamed from "Price"
      selector: (row) =>
        row.transactions && row.transactions.length > 0
          ? `${row.transactions[0].total_price} EGP`
          : "N/A",
      sortable: true,
    },
    {
      name: "Batch Value", // Renamed from "Net Price"
      selector: (row) => `${row.value || "N/A"} EGP`,
      sortable: true,
    },
  ];

  const tableDataModal = oneRow ? [oneRow] : []; // If oneRow exists, create an array with it

  // --- PDF Download Logic ---
  const handleDownload = async (row) => {
    const doc = new jsPDF("p", "mm", "a4");

    // Set logo
    const img = new Image();
    img.src = SmollLogo;
    doc.addImage(img, "PNG", 10, 10, 30, 30);

    // Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text(`Batch Details (ID: ${row.id})`, 150, 20, null, null, "right"); // Changed from Invoice to Batch Details

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const batchDate = new Date(row.created_at);
    const batchDateStr = batchDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    doc.text(`Batch Date: ${batchDateStr}`, 150, 30, null, null, "right");
    doc.text(
      `Supplier Branch: ${row.supplier_branch?.name || "N/A"}`,
      150,
      40,
      null,
      null,
      "right"
    ); // Added supplier branch info

    // Batch Details
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text(`Batch Code: ${row.batch_code || "N/A"}`, 10, 55); // Added batch code
    doc.text(`Batch Status: ${row.status || "N/A"}`, 10, 65); // Added batch status

    // Total Value of Batch
    doc.setFontSize(16);
    doc.setTextColor(0, 128, 0); // Green color
    doc.text(
      `Batch Value: ${row.value || "N/A"} EGP`,
      150,
      65,
      null,
      null,
      "right"
    ); // Use batch value

    const transaction = row.transactions?.[0];
    const tableBody = transaction
      ? [
          [
            row.variation?.sku || row.variation?.id || "N/A", // Product/Variation ID/SKU
            row.variation?.name || "N/A", // Product/Variation Name
            transaction.quantity, // Transaction Quantity
            `${transaction.unit_price} EGP`, // Transaction Unit Price
            `${transaction.total_price} EGP`, // Transaction Total Price
          ],
        ]
      : [];

    autoTable(doc, {
      startY: 75,
      head: [
        [
          "Product/Batch SKU/ID",
          "Product Name",
          "Quantity",
          "Unit Price",
          "Total Purchase Price",
        ],
      ], // Adjusted headers
      body: tableBody,
      theme: "striped",
      styles: { fontSize: 10, cellPadding: 3 },
      headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
      bodyStyles: { textColor: [0, 0, 0] },
    });

    let finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Batch Value:", 120, finalY);
    doc.text(`${row.value || "N/A"} EGP`, 180, finalY, null, null, "right");

    if (transaction) {
      doc.setFont("helvetica", "normal");
      doc.text("Total Purchase Price:", 120, finalY + 10);
      doc.text(
        `${transaction.total_price} EGP`,
        180,
        finalY + 10,
        null,
        null,
        "right"
      );
    }

    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(
      "Email: estbncompany@gmail.com | Phone: 01003247882 | Website: http://estbncompany.com",
      10,
      doc.internal.pageSize.height - 10
    );

    doc.save(`BatchDetails_${row.id}.pdf`);
  };

  const renderContent = () => {
    return (
      <DataTable
        columns={columns}
        data={batches}
        pagination
        highlightOnHover
        responsive
        className="custom-table"
        headerClassName="custom-header"
        rowClassName="custom-row"
        cellClassName="custom-cell"
        selectableRows
        selectableRowsHighlight
        onSelectedRowsChange={(state) => {
          setSelectedRows(state.selectedRows);
        }}
      />
    );
  };

  return (
    <>
      {/* Modal for Batch Details */}
      <Modal
        contentClassName="m-Sus_content"
        dialogClassName="m-SusO_dialog"
        show={show}
        onHide={close}
      >
        <Modal.Header closeButton>
          {" "}
          {/* Added closeButton */}
          <Modal.Title>Batch Details</Modal.Title> {/* Changed title */}
        </Modal.Header>
        <Modal.Body>
          <div className="title_susModelDetails">
            <div>
              {/* Use batch data for display */}
              <div className="orderId_model">Batch {oneRow?.id}</div>
              <span className="orderdata_model">
                {oneRow?.created_at
                  ? new Date(oneRow.created_at).toLocaleDateString()
                  : "N/A"}
                ,{" "}
                {oneRow?.created_at
                  ? new Date(oneRow.created_at).toLocaleTimeString()
                  : "N/A"}
              </span>
            </div>
            <div>
              <div>
                Batch Status : <span>{oneRow?.status || "N/A"}</span>
              </div>
              <div>
                {/* Display transaction type or batch value */}
                Transaction Type :{" "}
                <span>{oneRow?.transactions?.[0]?.type || "N/A"}</span>
              </div>
            </div>
          </div>
          {/* Display basic batch info like quantity, price, dates */}
          <div style={{ marginBottom: "15px" }}>
            <p>
              <strong>Batch Code:</strong> {oneRow?.batch_code || "N/A"}
            </p>
            <p>
              <strong>Supplier Branch:</strong>{" "}
              {oneRow?.supplier_branch?.name || "N/A"}
            </p>
            <p>
              <strong>Quantity:</strong> {oneRow?.quantity || "N/A"}
            </p>
            <p>
              <strong>Remaining Quantity:</strong>{" "}
              {oneRow?.remaining_quantity || "N/A"}
            </p>
            <p>
              <strong>Expiration Date:</strong>{" "}
              {oneRow?.expiration_date || "N/A"}
            </p>
            <p>
              <strong>Import Date:</strong> {oneRow?.import_date || "N/A"}
            </p>
            <p>
              <strong>Purchase Price (Unit):</strong>{" "}
              {oneRow?.purchase_price || "N/A"} EGP
            </p>
            <p>
              <strong>Selling Price (Unit):</strong>{" "}
              {oneRow?.selling_price || "N/A"} EGP
            </p>
          </div>

          <DataTable
            columns={columnsModel}
            data={tableDataModal} // Use data derived from oneRow
            highlightOnHover
            responsive
            className="custom-table"
            headerClassName="custom-header"
            rowClassName="custom-row"
            cellClassName="custom-cell"
            noDataComponent={<div>No batch details available for display.</div>} // Add message for empty modal data
          />
        </Modal.Body>
      </Modal>

      {/* Main content */}
      <div className="p-4 border rounded-2 my-1 min-vh-100">
        <div className="d-flex justify-content-between align-items-center custom-card-sm">
          <h5 className="">Batches Info</h5>

          <div className="input-group w-50  justify-content-end align-items-center rounded-2 ">
            <input
              type="text"
              className={
                "form-control  bg-transparent position-relative rounded "
              }
              placeholder={"Search"}
              value={searchForPermissions}
              onChange={(e) => {
                setSearchForPermissions((perv) => (perv = e.target.value));
              }}
            />
            <div className="position-absolute mx-2">
              <Search />
            </div>
          </div>
        </div>

        {/* {renderContent()} */}
        <div className="data-grid-small my-4">
          <Paper sx={{ height: "auto", width: "100%" }}>
            <DataGrid
              autoHeight
              rows={batches}
              columns={columns}
              initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[5, 10]}
              checkboxSelection
              sx={{ border: 0 }}
            />
          </Paper>
        </div>
      </div>
    </>
  );
};

export default Supplier_order;
